module.exports = "//public.getcloudapp.com/packs/media/images/app-icon-ee9e56acfc047a00f9035fe12eb92993.svg";